export default __webpack_public_path__ + "static/topic22-db01e6ab839610d41a38c5d40d046390.png";